import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCalendar, LazyContentCards, LazyContentIconHero, LazyFaqs, LazyForm, LazyMap, LazyMultiColumnChecklist, LazyNewsletter, LazyOffsetImagePods, LazyOwnershipListing, LazyPageHeader, LazyParkShowcase, LazyPromoSlider, LazyReviews, LazySalesShowcase, LazySbsContent, LazySbsImagePods, LazySbsTextMedia, LazyTestimonials, LazyTimeline, LazyVideo, LazyVirtualTour, LazyWysiwyg, LazyAccountDetails, LazyAccountHolidays, LazyAccountHome, LazyAccountPassword, LazyAccountPayments, LazyAccountPreferences, LazyAccountCardsHolidayCard, LazyAccountCardsLoginCard, LazyAccountCardsSignPost, LazyAccountUiBack, LazyAccountUiBooking, LazyAccountUiCarRegistration, LazyAccountUiConfirmation, LazyAccountUiGuests, LazyAccountUiInitials, LazyAccountUiPageBottom, LazyAccountUiPayments, LazyAccountUiTabs, LazyArticleHeader, LazyArticleRelated, LazyArticleView, LazyBookingAddressForm, LazyBookingCarReg, LazyBookingCard, LazyBookingCompletePaymentButton, LazyBookingCreateAccount, LazyBookingDetails, LazyBookingExpired, LazyBookingExtras, LazyBookingFooter, LazyBookingLogin, LazyBookingLogos, LazyBookingMailingList, LazyBookingNotes, LazyBookingPayment, LazyBookingStepInfo, LazyBookingSteps, LazyBookingSuccess, LazyBookingSummary, LazyBookingTerms, LazyBookingTimer, LazyBookingTransactionSummary, LazyCalendarDescription, LazyCalendarGallery, LazyCalendarIncluded, LazyCalendarMainTitle, LazyCalendarPicker, LazyCalendarTabs, LazyCalendarVirtualTour, LazyEventHeader, LazyEventMeta, LazyEventReviews, LazyEventView, LazyEventsPageHeader, LazyGlobalButton, LazyGlobalFooter, LazyGlobalHeader, LazyGlobalLoading, LazyGlobalLogin, LazyGlobalMegamenu, LazyGlobalMobileMenu, LazyGlobalNavigation, LazyGlobalNotificationBanner, LazyGlobalOTP, LazyGlobalPagination, LazyGlobalParkVuUptime, LazyGlobalPasswordResetEmail, LazyGlobalRegister, LazyGlobalSocialShare, LazyGlobalSubmitProvisional, LazyGlobalToggleButtons, LazyHomeCard, LazyHomeDescriptionComponent, LazyHomeFeaturesComponent, LazyHomeFinance, LazyHomeGlobalComponents, LazyHomeHeader, LazyHomeParkComponents, LazyHomePrice, LazyHomePromos, LazyHomeSlider, LazyHomeVideoTour, LazyHomeView, LazyHomeVirtualTour, LazyHomeEnquiryForm, LazyHomePrintBanner, LazyHomePrintMeta, LazyNewsFeaturedArticle, LazyNewsFilters, LazyNewsPageHeader, LazyOwnershipSearchbar, LazyOwnershipSlimSearchbar, LazyPartialsArticleListing, LazyPartialsBreadcrumbs, LazyPartialsContactForm, LazyPartialsEventListing, LazyPartialsLocationCard, LazyPartialsPageComponents, LazySearchAddBooking, LazySearchBar, LazySearchBarAmendDropdown, LazySearchDuration, LazySearchFilterResultsSlideout, LazySearchGuests, LazySearchHeader, LazySearchList, LazySearchMiniBasket, LazySearchRelatedEvents, LazySearchResultItem, LazySearchResultItemLoading, LazySearchResultProductDetails, LazySearchResultSlide, LazySearchResults, LazySearchResultsFilters, LazySearchType, LazySvgoArrowLeftLongThin, LazySvgoArrowRightLongThin, LazySvgoBedBlue, LazySvgoBed, LazySvgoBedrooms, LazySvgoCalendar, LazySvgoCheckCircle, LazySvgoChevronLeftCharcoal, LazySvgoChevronLeftTeal, LazySvgoChevronRightCharcoal, LazySvgoChevronRightTeal, LazySvgoClose, LazySvgoCoupon, LazySvgoCrossCircle, LazySvgoFilter, LazySvgoHeart, LazySvgoHome, LazySvgoHtlFilterArrow, LazySvgoIconHolidayHome, LazySvgoIconLodge, LazySvgoIconSquirrel, LazySvgoLocationPinYellow, LazySvgoLocationPin, LazySvgoLodge, LazySvgoLogoTripadvisor, LazySvgoMapClusterBackground, LazySvgoMapPin, LazySvgoMinus, LazySvgoNavigationLeft, LazySvgoNavigationRight, LazySvgoPawTeal, LazySvgoPaw, LazySvgoPersonBlue, LazySvgoPin, LazySvgoPlus, LazySvgoPool, LazySvgoPromo, LazySvgoRelatedEventsArrow, LazySvgoSearchWhite, LazySvgoSearch, LazySvgoSquirrelCharcoal75, LazySvgoSquirrel, LazySvgoToggleDownDark, LazySvgoUser, LazySvgoUsers, LazyScriptAriaLoadingIndicator, LazyScriptCarbonAds, LazyScriptCrisp, LazyScriptGoogleAdsense, LazyScriptGoogleMaps, LazyScriptIntercom, LazyScriptLemonSqueezy, LazyScriptLoadingIndicator, LazyScriptStripePricingTable, LazyScriptVimeoPlayer, LazyScriptYouTubePlayer, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["Calendar", LazyCalendar],
["ContentCards", LazyContentCards],
["ContentIconHero", LazyContentIconHero],
["Faqs", LazyFaqs],
["Form", LazyForm],
["Map", LazyMap],
["MultiColumnChecklist", LazyMultiColumnChecklist],
["Newsletter", LazyNewsletter],
["OffsetImagePods", LazyOffsetImagePods],
["OwnershipListing", LazyOwnershipListing],
["PageHeader", LazyPageHeader],
["ParkShowcase", LazyParkShowcase],
["PromoSlider", LazyPromoSlider],
["Reviews", LazyReviews],
["SalesShowcase", LazySalesShowcase],
["SbsContent", LazySbsContent],
["SbsImagePods", LazySbsImagePods],
["SbsTextMedia", LazySbsTextMedia],
["Testimonials", LazyTestimonials],
["Timeline", LazyTimeline],
["Video", LazyVideo],
["VirtualTour", LazyVirtualTour],
["Wysiwyg", LazyWysiwyg],
["AccountDetails", LazyAccountDetails],
["AccountHolidays", LazyAccountHolidays],
["AccountHome", LazyAccountHome],
["AccountPassword", LazyAccountPassword],
["AccountPayments", LazyAccountPayments],
["AccountPreferences", LazyAccountPreferences],
["AccountCardsHolidayCard", LazyAccountCardsHolidayCard],
["AccountCardsLoginCard", LazyAccountCardsLoginCard],
["AccountCardsSignPost", LazyAccountCardsSignPost],
["AccountUiBack", LazyAccountUiBack],
["AccountUiBooking", LazyAccountUiBooking],
["AccountUiCarRegistration", LazyAccountUiCarRegistration],
["AccountUiConfirmation", LazyAccountUiConfirmation],
["AccountUiGuests", LazyAccountUiGuests],
["AccountUiInitials", LazyAccountUiInitials],
["AccountUiPageBottom", LazyAccountUiPageBottom],
["AccountUiPayments", LazyAccountUiPayments],
["AccountUiTabs", LazyAccountUiTabs],
["ArticleHeader", LazyArticleHeader],
["ArticleRelated", LazyArticleRelated],
["ArticleView", LazyArticleView],
["BookingAddressForm", LazyBookingAddressForm],
["BookingCarReg", LazyBookingCarReg],
["BookingCard", LazyBookingCard],
["BookingCompletePaymentButton", LazyBookingCompletePaymentButton],
["BookingCreateAccount", LazyBookingCreateAccount],
["BookingDetails", LazyBookingDetails],
["BookingExpired", LazyBookingExpired],
["BookingExtras", LazyBookingExtras],
["BookingFooter", LazyBookingFooter],
["BookingLogin", LazyBookingLogin],
["BookingLogos", LazyBookingLogos],
["BookingMailingList", LazyBookingMailingList],
["BookingNotes", LazyBookingNotes],
["BookingPayment", LazyBookingPayment],
["BookingStepInfo", LazyBookingStepInfo],
["BookingSteps", LazyBookingSteps],
["BookingSuccess", LazyBookingSuccess],
["BookingSummary", LazyBookingSummary],
["BookingTerms", LazyBookingTerms],
["BookingTimer", LazyBookingTimer],
["BookingTransactionSummary", LazyBookingTransactionSummary],
["CalendarDescription", LazyCalendarDescription],
["CalendarGallery", LazyCalendarGallery],
["CalendarIncluded", LazyCalendarIncluded],
["CalendarMainTitle", LazyCalendarMainTitle],
["CalendarPicker", LazyCalendarPicker],
["CalendarTabs", LazyCalendarTabs],
["CalendarVirtualTour", LazyCalendarVirtualTour],
["EventHeader", LazyEventHeader],
["EventMeta", LazyEventMeta],
["EventReviews", LazyEventReviews],
["EventView", LazyEventView],
["EventsPageHeader", LazyEventsPageHeader],
["GlobalButton", LazyGlobalButton],
["GlobalFooter", LazyGlobalFooter],
["GlobalHeader", LazyGlobalHeader],
["GlobalLoading", LazyGlobalLoading],
["GlobalLogin", LazyGlobalLogin],
["GlobalMegamenu", LazyGlobalMegamenu],
["GlobalMobileMenu", LazyGlobalMobileMenu],
["GlobalNavigation", LazyGlobalNavigation],
["GlobalNotificationBanner", LazyGlobalNotificationBanner],
["GlobalOTP", LazyGlobalOTP],
["GlobalPagination", LazyGlobalPagination],
["GlobalParkVuUptime", LazyGlobalParkVuUptime],
["GlobalPasswordResetEmail", LazyGlobalPasswordResetEmail],
["GlobalRegister", LazyGlobalRegister],
["GlobalSocialShare", LazyGlobalSocialShare],
["GlobalSubmitProvisional", LazyGlobalSubmitProvisional],
["GlobalToggleButtons", LazyGlobalToggleButtons],
["HomeCard", LazyHomeCard],
["HomeDescriptionComponent", LazyHomeDescriptionComponent],
["HomeFeaturesComponent", LazyHomeFeaturesComponent],
["HomeFinance", LazyHomeFinance],
["HomeGlobalComponents", LazyHomeGlobalComponents],
["HomeHeader", LazyHomeHeader],
["HomeParkComponents", LazyHomeParkComponents],
["HomePrice", LazyHomePrice],
["HomePromos", LazyHomePromos],
["HomeSlider", LazyHomeSlider],
["HomeVideoTour", LazyHomeVideoTour],
["HomeView", LazyHomeView],
["HomeVirtualTour", LazyHomeVirtualTour],
["HomeEnquiryForm", LazyHomeEnquiryForm],
["HomePrintBanner", LazyHomePrintBanner],
["HomePrintMeta", LazyHomePrintMeta],
["NewsFeaturedArticle", LazyNewsFeaturedArticle],
["NewsFilters", LazyNewsFilters],
["NewsPageHeader", LazyNewsPageHeader],
["OwnershipSearchbar", LazyOwnershipSearchbar],
["OwnershipSlimSearchbar", LazyOwnershipSlimSearchbar],
["PartialsArticleListing", LazyPartialsArticleListing],
["PartialsBreadcrumbs", LazyPartialsBreadcrumbs],
["PartialsContactForm", LazyPartialsContactForm],
["PartialsEventListing", LazyPartialsEventListing],
["PartialsLocationCard", LazyPartialsLocationCard],
["PartialsPageComponents", LazyPartialsPageComponents],
["SearchAddBooking", LazySearchAddBooking],
["SearchBar", LazySearchBar],
["SearchBarAmendDropdown", LazySearchBarAmendDropdown],
["SearchDuration", LazySearchDuration],
["SearchFilterResultsSlideout", LazySearchFilterResultsSlideout],
["SearchGuests", LazySearchGuests],
["SearchHeader", LazySearchHeader],
["SearchList", LazySearchList],
["SearchMiniBasket", LazySearchMiniBasket],
["SearchRelatedEvents", LazySearchRelatedEvents],
["SearchResultItem", LazySearchResultItem],
["SearchResultItemLoading", LazySearchResultItemLoading],
["SearchResultProductDetails", LazySearchResultProductDetails],
["SearchResultSlide", LazySearchResultSlide],
["SearchResults", LazySearchResults],
["SearchResultsFilters", LazySearchResultsFilters],
["SearchType", LazySearchType],
["SvgoArrowLeftLongThin", LazySvgoArrowLeftLongThin],
["SvgoArrowRightLongThin", LazySvgoArrowRightLongThin],
["SvgoBedBlue", LazySvgoBedBlue],
["SvgoBed", LazySvgoBed],
["SvgoBedrooms", LazySvgoBedrooms],
["SvgoCalendar", LazySvgoCalendar],
["SvgoCheckCircle", LazySvgoCheckCircle],
["SvgoChevronLeftCharcoal", LazySvgoChevronLeftCharcoal],
["SvgoChevronLeftTeal", LazySvgoChevronLeftTeal],
["SvgoChevronRightCharcoal", LazySvgoChevronRightCharcoal],
["SvgoChevronRightTeal", LazySvgoChevronRightTeal],
["SvgoClose", LazySvgoClose],
["SvgoCoupon", LazySvgoCoupon],
["SvgoCrossCircle", LazySvgoCrossCircle],
["SvgoFilter", LazySvgoFilter],
["SvgoHeart", LazySvgoHeart],
["SvgoHome", LazySvgoHome],
["SvgoHtlFilterArrow", LazySvgoHtlFilterArrow],
["SvgoIconHolidayHome", LazySvgoIconHolidayHome],
["SvgoIconLodge", LazySvgoIconLodge],
["SvgoIconSquirrel", LazySvgoIconSquirrel],
["SvgoLocationPinYellow", LazySvgoLocationPinYellow],
["SvgoLocationPin", LazySvgoLocationPin],
["SvgoLodge", LazySvgoLodge],
["SvgoLogoTripadvisor", LazySvgoLogoTripadvisor],
["SvgoMapClusterBackground", LazySvgoMapClusterBackground],
["SvgoMapPin", LazySvgoMapPin],
["SvgoMinus", LazySvgoMinus],
["SvgoNavigationLeft", LazySvgoNavigationLeft],
["SvgoNavigationRight", LazySvgoNavigationRight],
["SvgoPawTeal", LazySvgoPawTeal],
["SvgoPaw", LazySvgoPaw],
["SvgoPersonBlue", LazySvgoPersonBlue],
["SvgoPin", LazySvgoPin],
["SvgoPlus", LazySvgoPlus],
["SvgoPool", LazySvgoPool],
["SvgoPromo", LazySvgoPromo],
["SvgoRelatedEventsArrow", LazySvgoRelatedEventsArrow],
["SvgoSearchWhite", LazySvgoSearchWhite],
["SvgoSearch", LazySvgoSearch],
["SvgoSquirrelCharcoal75", LazySvgoSquirrelCharcoal75],
["SvgoSquirrel", LazySvgoSquirrel],
["SvgoToggleDownDark", LazySvgoToggleDownDark],
["SvgoUser", LazySvgoUser],
["SvgoUsers", LazySvgoUsers],
["ScriptAriaLoadingIndicator", LazyScriptAriaLoadingIndicator],
["ScriptCarbonAds", LazyScriptCarbonAds],
["ScriptCrisp", LazyScriptCrisp],
["ScriptGoogleAdsense", LazyScriptGoogleAdsense],
["ScriptGoogleMaps", LazyScriptGoogleMaps],
["ScriptIntercom", LazyScriptIntercom],
["ScriptLemonSqueezy", LazyScriptLemonSqueezy],
["ScriptLoadingIndicator", LazyScriptLoadingIndicator],
["ScriptStripePricingTable", LazyScriptStripePricingTable],
["ScriptVimeoPlayer", LazyScriptVimeoPlayer],
["ScriptYouTubePlayer", LazyScriptYouTubePlayer],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
